<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <h3 class="title">物流异常单据跟进</h3>
    <affix>
      <div v-if="conditions.status === 'E005'" class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <div v-if="conditions.status != 'E005'" class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="提交" icon="form-advance" @click="saveData('E005')" />
        <form-button name="保存" type="primary" @click="saveData('E004')" />
      </div>
    </affix>

    <div class="form-container">
      <el-form
        inline
        size="mini"
        :disabled="conditions.status === 'E005'"
        label-width="100px"
        :model="conditions"
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="异常单号" prop="dealers">
              <el-input v-model="conditions.abnoramlBillCode" placeholder="自动生成" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" label="创建人">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.createdDate"
                type="date"
                value-format="yyyy-MM-dd"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="来源">
              <el-select v-model="conditions.source" disabled>
                <el-option
                  v-for="item in selectDataOptions['WLYCSource']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="要求处理时间">
              <el-date-picker
                v-model="conditions.requireProcessDate"
                type="date"
                disabled
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="安吉反馈时间">
              <el-date-picker
                v-model="conditions.feedbackDate"
                type="date"
                disabled
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="客户反馈情况">
              <el-input
                v-model="conditions.responsecontent"
                placeholder="请输入"
                resize="none"
                disabled
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.comment"
                placeholder="请输入"
                resize="none"
                disabled
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安吉反馈">
              <el-input
                v-model="conditions.feedback"
                placeholder="请输入"
                resize="none"
                disabled
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="处理反馈情况">
              <el-input
                v-model="conditions.handlefeedback"
                placeholder="请输入"
                resize="none"
                :autosize="{ minRows: 2, maxRows: 2 }"
                type="textarea"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="*最终处理结果">
              <el-radio v-model="conditions.finalProcessResult" label="1">算安吉责任</el-radio>
              <el-radio v-model="conditions.finalProcessResult" label="0">不算安吉责任，取消异常</el-radio>
            </el-form-item>
          </el-col>

          <template v-if="conditions.finalProcessResult == '1'">
            <el-col :span="8">
              <el-form-item label="考核标准">
                <el-select v-model="conditions.punishStandwardCode">
                  <el-option
                    v-for="item in selectDataOptions['YCDJpunish']"
                    :key="item.id"
                    :value="item.value"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考核指标">
                <el-select v-model="conditions.quotaNo" @change="onChangeQuotaNo">
                  <el-option
                    v-for="item in selectDataOptions['YCDpunishitem']"
                    :key="item.id"
                    :value="item.value"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所处罚金(元)">
                <el-input v-model="conditions.punishAmount" type="number" />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="发货单明细" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <!--table-button tip="新增" name="add" @click="addRow" />
          <table-button tip="删除" name="delete" @click="delRow" /-->
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="250"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>

    <div class="table-container">
      <TableCommon title="附件信息" :custome-config="() => vxeShowCustom('xTable3')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="100"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template v-for="item in gridOptions2.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions2.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                size="mini"
              />
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { webUploadFile } from '@/api/common'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import {
  apiSaveAbnormalLogistic,
  apiAbnormallogisticFindById,
  apiQueryAbnormalLogisticDeliver
} from '@/api/applyForGoods/logisticsAbnormal'
export default {
  name: 'LogisticsExceptionFollow',

  data() {
    const rules = {
      finalProcessResult: [{ required: true, message: '请选择最终处理结果', trigger: 'change' }]
    }
    return {
      rules,
      loading: false,
      showDialog: false,
      selectDataOptions: {},
      clientDialog: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        abnoramlBillCode: '',
        fhd: '',
        source: '1',
        handlefeedback: '',
        feedback: '',
        comment: '',
        content: '',
        customer: '',
        expirationDate: '',
        punishStandwardItem: '',
        punishStandwardCode: '',
        punishStandward: '',
        punishAmount: '',
        requireProcessDate: '',
        status: '',
        createdDate: '',
        feedbackDate: '',
        quotaNo: '',
        finalProcessResult: '0'
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          { field: 'wantCode', title: '发货单号', width: 120 },
          { field: 'customerName', title: '客户名称', width: 150 },
          { field: 'productDesc', title: '产品', width: 160 },
          { field: 'warehouse', title: '发货仓库', width: 160 },
          { field: 'wantDate', title: '申请时间', width: 150 },
          { field: 'wantQuantity', title: '申请量', width: 120 },
         // { field: 'payfreight', title: '应付运费', width: 120 },
          { field: 'shouldArrivedate', title: '应到货时间', width: 120 },
          { field: 'deliverQuantity', title: '实际发货量', width: 120 },
          { field: 'freight', title: '实际运费', width: 120 },
          { field: 'reachedTime', title: '安吉到货时间', width: 140 },
          { field: 'signdate', title: '客户签收时间', width: 140 },
          { field: 'receivecityname', title: '收货城市', width: 100 },
          { field: 'logisticno',title: '运单号', width: 100 },
          { title: '客户评价', field: 'commentResult' ,width:100},
          { title: '客户评价内容', field: 'feedbackByCustomer' ,width:100},
          { title: '签收备注', field: 'signRemark' ,width:100},
          { field: 'anjiRemark', title: '备注(安吉提供原因分类）', width: 180 }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' },
            editRender: { name: 'input' }
          },
          {
            field: 'fileType',
            title: '附件类型',
            slots: { default: 'fileType' },
            editRender: { name: 'input' }
          },
          {
            field: 'fileSize',
            title: '大小',
            slots: { default: 'fileSize' },
            editRender: { name: 'input' }
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' },
            editRender: { name: 'input' }
          }
        ],
        data: []
      },
      fileDetail: {
        id: '',
        fileName: ''
      }
    }
  },
  watch: {
    '$route.query': {
      handler(nv) {
        if (nv.id) {
          this.init(nv.id)
        }
      },
      deep: true
    }
    // 'conditions.finalProcessResult': {
    //   handler(nv) {
    //     if (nv === '2') {
    //       this.conditions.punishStandwardCode = ''
    //       this.conditions.quotaNo = ''
    //       this.conditions.punishAmount = ''
    //     }
    //   }
    // }
  },
  created() {
    const id = this.$route.query.id
    this.init(id)
  },
  methods: {
    async init(id) {
      this.getSelectDictDataOrigin('WLYCSource')
      this.getSelectDictDataOrigin('YCDJpunish')
      this.getSelectDictDataOrigin('YCDpunishitem')
      const { data } = await apiAbnormallogisticFindById({ id })
      Object.assign(this.conditions, data)
      // page && (this.pagination.page = page)
      const params = { ...this.conditions, ...this.pagination }
      try {
        const {
          data: { Rows, Total }
        } = await apiQueryAbnormalLogisticDeliver(params)
        // console.log('rowss=======',Rows)
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        console.log(e)
      }
    },
    async saveData(type) {
      this.loading = false
      if (this.conditions.status === 'E004') {
        //alert(this.conditions.finalProcessResult)
        if (this.conditions.finalProcessResult === null) {
          this.$message.warning('请选择最终处理结果！')
          return
        }
        this.conditions.status = type
        const params = {
          ...this.conditions
        }
        try {
          const { data, status } = await apiSaveAbnormalLogistic(params)
          // if (status === 1) {
          Object.assign(this.conditions, data)
          // }
        } catch (e) {
          //
        }
      } else if (this.conditions.status === 'E005') {
        this.$message.warning('已经处理完成！')
      } else {
        this.$message.warning('安吉未反馈信息，不能进行跟进处理！')
      }
      this.loading = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('bizId', 789456)
      formData.append('bizCode', 55552)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      data.file_id = data.id
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    // 删除附件
    delUpload() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions2.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.data.splice(index, 1)
      })
    },
    onChangeQuotaNo(value) {
      const quota = this.selectDataOptions['YCDpunishitem'].find(v => v.value === value)
      if (quota) {
        this.conditions.quotaName = quota.name
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/LogisticsExceptionFollow.vue